import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DriverDetailsData } from "../../drivers.types";
import { requestGetDriverById } from "./getDriverById.request";

const useGetDriverById = (
  driverId: string,
  options?: QueryOptions<DriverDetailsData, ApiServiceError<ApiError>>
) => {
  const { data: driver, ...rest } = useQuery({
    queryKey: ["driver", "admin", "one", driverId],
    queryFn: async () => {
      return await requestGetDriverById(driverId);
    },
    enabled: !!driverId,
    cacheTime: 0,
    ...options
  });

  return { driver, ...rest };
};

export default useGetDriverById;
